export const SET_ACTIVE_BENCHMARK = 'SET_ACTIVE_BENCHMARK';

export const setActiveBenchmark = benchmark => ({
  type: SET_ACTIVE_BENCHMARK,
  activeBenchmark: benchmark,
});
